import React from 'react';
import 'react-toastify/dist/ReactToastify.css';
import Header from './header/Header';
import { useMediaQuery } from 'react-responsive'
import Button from '../components/basic/Button';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { IconsLibrary } from "../util/FontAwesomeIconsUtil";

function DefaultLayout({ topline, topLinePrivateProfile, sidebar, profileView, isReviewPage, page, children }) {

    const isDesktopOrLaptop = useMediaQuery({ query: '(min-width: 1280px)' });
    const isSmallerDesktop = useMediaQuery({ query: '(min-width: 1024px) and (max-width: 1279px)' });
    // const isTablet = useMediaQuery({ query: '(min-width: 680px and max-width: 1280px)' })
    // const isMobile = useMediaQuery({ query: '(max-width: 450px)' })

    const [sidebarOpen, setSidebarOpen] = React.useState(false);

    return (
        <>
            <Header page={page} />
            <div className="main">
                {!!topline && (
                    <div className="sm:pt-6 sm:pb-0 md:pt-6 md:pb-0 lg:py-6 bg-gray-lightest">
                        {topline}
                    </div>
                )}
                {(!!isSmallerDesktop || !!isDesktopOrLaptop) && !!topLinePrivateProfile && (
                    <div className="sm:pt-6 sm:pb-0 md:pt-6 md:pb-0 lg:py-6 bg-gray-lightest">
                        {topLinePrivateProfile}
                    </div>
                )}
                {!!sidebar && (
                    <>
                        {!!isDesktopOrLaptop && <div className="px-3">
                            <div className="container mx-auto py-4">
                                <div className="flex flex-nowrap overflow-hidden -mx-3">
                                    <div className="flex-shrink-0 w-full max-w-xs px-3 overflow-hidden">
                                        {sidebar}
                                    </div>
                                    <div className="flex-grow px-3 overflow-hidden">
                                        {children}
                                    </div>
                                </div>
                            </div>
                        </div>}
                        {!isDesktopOrLaptop && <div className="px-3">
                            {!isReviewPage && (
                                <div className="container mx-auto pt-2 text-right">
                                <Button onClick={() => setSidebarOpen(!sidebarOpen)} type="button" variant="tertiary">
                                    {!sidebarOpen && <FontAwesomeIcon icon={IconsLibrary.faTimes} className="text-lg" />}
                                    {!!sidebarOpen && <FontAwesomeIcon icon={IconsLibrary.faBars} className="text-lg" />}
                                </Button>
                            </div>
                            )}
                            {!isSmallerDesktop && (
                            <div className="max-w-xl mx-auto pt-3">
                                {profileView}
                            </div>
                            )}
                            {!sidebarOpen && (
                                <div className="max-w-lg mx-auto">
                                    {sidebar}
                                </div>
                            )}
                            <div className="container mx-auto py-3">
                                {children}
                            </div>
                        </div>}
                    </>
                )}
                {!sidebar && children}
            </div>
        </>
    );
}

export default DefaultLayout;